import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCta from "@/components/StickyMobileCta";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Cleaning from "@/pages/Cleaning";
import Maintenance from "@/pages/Maintenance";
import Inspections from "@/pages/Inspections";
import ForHomeowners from "@/pages/ForHomeowners";
import Pricing from "@/pages/Pricing";
import StartAirbnb from "@/pages/StartAirbnb";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Assessment from "@/pages/Assessment";
import Consultation from "@/pages/Consultation";
import GuestSupport from "@/pages/GuestSupport";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import OwnerLogin from "@/pages/OwnerLogin";
import OwnerDashboard from "@/pages/OwnerDashboard";
import Loyalty from "@/pages/Loyalty";
import BucketList from "@/pages/BucketList";
import TransportQuiz from "@/pages/TransportQuiz";
import PlanYourStay from "@/pages/PlanYourStay";
import GuestTools from "@/pages/GuestTools";
import Guides from "@/pages/Guides";
import CalendarBuilder from "@/pages/CalendarBuilder";
import Plan from "@/pages/Plan";

import Pay from "@/pages/Pay";
import Reviews from "@/pages/Reviews";
import Legal from "@/pages/Legal";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 150);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/co-hosting" element={<ServiceDetail slug="airbnb-vrbo-co-hosting" />} />
              <Route path="/property-management" element={<ServiceDetail slug="full-service-property-management" />} />
              <Route path="/cleaning" element={<Cleaning />} />
              <Route path="/maintenance" element={<Maintenance />} />
              <Route path="/inspections" element={<Inspections />} />
              <Route path="/for-homeowners" element={<ForHomeowners />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/start-your-airbnb" element={<StartAirbnb />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/consultation" element={<Consultation />} />
              <Route path="/guest-support" element={<GuestSupport />} />
              <Route path="/loyalty" element={<Loyalty />} />
              <Route path="/resources" element={<Blog />} />
              <Route path="/resources/:slug" element={<BlogPost />} />
              <Route path="/owner/login" element={<OwnerLogin />} />
              <Route path="/owner" element={<OwnerDashboard />} />
              <Route path="/bermuda-bucket-list" element={<BucketList />} />
              <Route path="/guest-tools" element={<GuestTools />} />
              <Route path="/guest-tools/getting-around-bermuda" element={<TransportQuiz />} />
              <Route path="/guest-tools/plan-your-stay" element={<PlanYourStay />} />
              <Route path="/blueprint" element={<Navigate to="/guides" replace />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/calendar" element={<CalendarBuilder />} />
              <Route path="/plan" element={<Plan />} />
              <Route path="/pay" element={<Pay />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="/privacy" element={<Legal />} />
              <Route path="/terms" element={<Legal />} />
              <Route path="/disclaimer" element={<Legal />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <StickyMobileCta />
            <Toaster position="bottom-right" toastOptions={{ style: { background: "#0F1C2E", color: "#FAF8F5", border: "1px solid rgba(232,165,152,0.3)", borderRadius: 0 } }} />
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
